<div class="error-modal">
  <h1 class="error-modal__title">{{ title }}</h1>
  <div class="error-modal__content">
    <div *ngFor="let error of errors" class="error-modal__content__error">
      <div>{{ error }}</div>
    </div>
  </div>
  <div class="error-modal__actions">
    <div class="error-modal__actions__button">
      <ui-button
        (handleClick)="closeModal($event)"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="error-modal-close"
        buttonText="Close"
        gtmTag="error-modal-close"
      ></ui-button>
    </div>
  </div>
</div>
